import React, { useState } from 'react';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import { useTranslation } from 'react-i18next';

import AdditionalInformation from './components/AdditionalInformation';
import AssistanceAndButtons from './components/AssistanceAndButtons';
import CardHeader from './components/CardHeader';
import { 
  Company, 
  InsuranceParameters, 
  Offers, 
  SetInsurance,
  IInsurance,
  SetInsuranceParameters 
} from '../../types';
import { 
  CardContent, 
  ExpandWrapper, 
  Expand, 
  Wrapper,
  ExpandText 
} from './style';

type Props = {
  offer: Offers;
  company: Company;
  insurance: IInsurance;
  insuranceParameters: InsuranceParameters; 
  setInsurance: SetInsurance; 
  setInsuranceParameters: SetInsuranceParameters; 
};

const InsuranceCard: React.FC<Props> = ({
  offer,
  company,
  insuranceParameters,
  insurance,
  setInsurance,
  setInsuranceParameters
}) => {
  const { t } = useTranslation();
  const [expand, setExpand] = useState(false);

  const handleExpand = () => {
    setExpand(!expand);
  };

  return (
    <Wrapper expand={expand}>
      <CardContent>
        <CardHeader
          offer={offer}
          company={company}
          insurance={insurance}
          insuranceParameters={insuranceParameters}
          setInsurance={setInsurance}
          setInsuranceParameters={setInsuranceParameters}
        />       
        <ExpandWrapper onClick={handleExpand}>
          <ExpandText>{t('details')}</ExpandText>
          <Expand expand={expand}>
            <KeyboardArrowRightOutlinedIcon/>
          </Expand>
        </ExpandWrapper>
        <AdditionalInformation company={company} />
        <AssistanceAndButtons company={company} />
      </CardContent>
    </Wrapper>
  );
};

export default InsuranceCard;
